import React from "react";
import { useRouteMatch } from "react-router";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import { LoginPage } from "./routes/login";
import { LoginEmailPage } from "./routes/login-email";
import { LoginPasswordPage } from "./routes/login-password";
import { PasswordRecoveryPage } from "./routes/password-recovery";
import { RecoveryPage } from "./routes/recovery";

export const App = () => {
  const { path, params } = useRouteMatch();

  return (
    <div>
      <Router>
        <Switch>
          <Route exact path={`${path}/login`}>
            <LoginPage />
          </Route>
          <Route exact path={`${path}/login-password`}>
            <LoginPasswordPage />
          </Route>
          <Route exact path={`${path}/login-email`}>
            <LoginEmailPage />
          </Route>
          <Route exact path={`${path}/recovery`}>
            <RecoveryPage />
          </Route>
          <Route exact path={`${path}/password-recovery/:token`}>
            <PasswordRecoveryPage />
          </Route>
          <Redirect to={{ pathname: `/${params["locale"]}/login`, search: window.location.search }} />
        </Switch>
      </Router>
    </div>
  );
};
